/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Table, Tag, Button, Input, Modal, Form, Switch, Space, Card, Typography, message, Popconfirm } from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { getAuthHeaders } from './jobManagementUtils';
import './JobManagement.css';

const { Text } = Typography;

function JobCategoryManagement(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();

  const authHeaders = getAuthHeaders(props.permitdata?.token);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        (props.app_hostname || '') + '/api/market/management/jobs/categories',
        {},
        { headers: authHeaders }
      );
      if (res.data && res.data.status === 'Success') {
        setData(res.data.data?.items || []);
      }
    } catch (err) {
      message.error('ไม่สามารถดึงข้อมูลหมวดหมู่วิชาชีพได้');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleOpenAdd = () => {
    setEditingCategory(null);
    form.resetFields();
    form.setFieldsValue({ is_active: true, sort_order: (data.length + 1) * 1 });
    setIsModalOpen(true);
  };

  const handleOpenEdit = (record) => {
    setEditingCategory(record);
    form.setFieldsValue({
      category_code: record.category_code,
      title_th: record.title_th,
      title_en: record.title_en,
      icon_class: record.icon_class,
      sort_order: record.sort_order,
      is_active: record.is_active,
    });
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const params = new URLSearchParams();
      if (editingCategory) {
        params.append('id', editingCategory.id);
      }
      params.append('category_code', values.category_code || '');
      params.append('title_th', values.title_th || '');
      params.append('title_en', values.title_en || '');
      params.append('icon_class', values.icon_class || 'mdi-briefcase');
      params.append('sort_order', values.sort_order || 1);
      params.append('is_active', values.is_active ? '1' : '0');

      const res = await axios.post(
        (props.app_hostname || '') + '/api/market/management/jobs/save_category',
        params,
        { headers: authHeaders }
      );
      if (res.data && res.data.status === 'Success') {
        message.success(res.data.message || 'บันทึกสำเร็จ');
        setIsModalOpen(false);
        fetchCategories();
      } else {
        message.error(res.data?.message || 'เกิดข้อผิดพลาดในการบันทึก');
      }
    } catch (err) {
      message.error('กรุณากรอกข้อมูลให้ครบถ้วน');
    }
  };

  const handleDelete = async (id) => {
    try {
      const params = new URLSearchParams();
      params.append('id', id);
      const res = await axios.post(
        (props.app_hostname || '') + '/api/market/management/jobs/delete_category',
        params,
        { headers: authHeaders }
      );
      if (res.data && res.data.status === 'Success') {
        message.success('ลบหมวดหมู่เรียบร้อยแล้ว');
        fetchCategories();
      } else {
        message.error(res.data?.message || 'เกิดข้อผิดพลาดในการลบ');
      }
    } catch (err) {
      message.error('เกิดข้อผิดพลาดในการลบ');
    }
  };

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'sort_order',
      key: 'sort_order',
      width: 80,
      align: 'center',
    },
    {
      title: 'ไอคอน',
      dataIndex: 'icon_class',
      key: 'icon_class',
      width: 100,
      align: 'center',
      render: (icon) => (
        <span style={{ fontSize: 20, color: '#1890ff' }}>
          <i className={`mdi ${icon}`}></i>
        </span>
      ),
    },
    {
      title: 'ชื่อสายวิชาชีพ (ไทย)',
      dataIndex: 'title_th',
      key: 'title_th',
      render: (text) => <span style={{ fontWeight: 600 }}>{text}</span>,
    },
    {
      title: 'Category Code',
      dataIndex: 'category_code',
      key: 'category_code',
      render: (code) => <Tag color='blue'>{code}</Tag>,
    },
    {
      title: 'จำนวนประกาศงานจริง',
      dataIndex: 'job_count',
      key: 'job_count',
      align: 'center',
      render: (count) => <Tag color={count > 0 ? 'green' : 'default'}>{count || 0} ตำแหน่ง</Tag>,
    },
    {
      title: 'สถานะ',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 120,
      render: (active) =>
        active ? <Tag color='success'>เปิดใช้งาน</Tag> : <Tag color='default'>ปิดใช้งาน</Tag>,
    },
    {
      title: 'จัดการ',
      key: 'actions',
      width: 150,
      render: (_, record) => (
        <Space size='small'>
          <Button
            size='small'
            icon={<EditOutlined />}
            onClick={() => handleOpenEdit(record)}
          />
          <Popconfirm
            title='ยืนยันการลบหมวดหมู่'
            description='ต้องการลบหมวดหมู่วิชาชีพนี้หรือไม่?'
            onConfirm={() => handleDelete(record.id)}
            okText='ลบ'
            cancelText='ยกเลิก'
          >
            <Button size='small' danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className='job-management-container'>
      <div className='job-management-header'>
        <div>
          <h2>🏥 จัดการหมวดหมู่วิชาชีพการแพทย์ & สาธารณสุข (Categories)</h2>
          <Text type='secondary'>
            ดึงข้อมูลและจัดการหมวดหมู่จริงจากฐานข้อมูล ({data.length} หมวดหมู่) สำหรับตัวกรองการค้นหางาน
          </Text>
        </div>
        <Space>
          <Button icon={<ReloadOutlined />} onClick={fetchCategories}>
            รีเฟรช
          </Button>
          <Button type='primary' icon={<PlusOutlined />} onClick={handleOpenAdd}>
            เพิ่มหมวดหมู่วิชาชีพ
          </Button>
        </Space>
      </div>

      <Card className='job-management-card'>
        <Table
          columns={columns}
          dataSource={data}
          rowKey='id'
          loading={loading}
          pagination={false}
        />
      </Card>

      <Modal
        title={editingCategory ? 'แก้ไขหมวดหมู่วิชาชีพ' : 'เพิ่มหมวดหมู่วิชาชีพใหม่'}
        open={isModalOpen}
        onOk={handleSave}
        onCancel={() => setIsModalOpen(false)}
        okText='บันทึก'
        cancelText='ยกเลิก'
      >
        <Form form={form} layout='vertical' style={{ marginTop: 16 }}>
          <Form.Item
            name='title_th'
            label='ชื่อวิชาชีพ (ภาษาไทย)'
            rules={[{ required: true, message: 'กรุณากรอกชื่อวิชาชีพภาษาไทย' }]}
          >
            <Input placeholder='เช่น แพทย์, พยาบาล, เภสัชกร' />
          </Form.Item>

          <Form.Item
            name='category_code'
            label='รหัสหมวดหมู่ (Category Code)'
            rules={[{ required: true, message: 'กรุณากรอกรหัสหมวดหมู่' }]}
          >
            <Input placeholder='เช่น doctor, nurse, pharmacist' />
          </Form.Item>

          <Form.Item name='icon_class' label='ไอคอน Material Design (Icon Class)'>
            <Input placeholder='เช่น mdi-stethoscope, mdi-pill' />
          </Form.Item>

          <Form.Item name='sort_order' label='ลำดับการแสดงผล'>
            <Input type='number' />
          </Form.Item>

          <Form.Item name='is_active' label='สถานะการเปิดใช้งาน' valuePropName='checked'>
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default JobCategoryManagement;
